app.directive('selectSingleLocation', ['$filter', function ($filter) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            'title': '@',
            'default': '@',
            'disable': '=',
            'removetitle': '@',
            'data': '=',
            'selectedText': '@',
            'selectedItem': '=',
            'classDropdown': '@',
            'titleclass': '@',
            'simpledata': '@',
            'takecode': '@',
            'ngmodel': '=',
            'ngchange': '@',
            'disabled': '@',
            'useSelectedText': '@'
        },
        templateUrl: "application/templates/directives/selectSingleLocation.html",

        controller: function ($scope) {
            $scope.removetitle = false;
            // init combo if data exist
            if ($scope.selectedItem && $scope.selectedItem.name) {
               
                $scope.removetitle = true;
            }

            if ($scope.selectedText) {
               
                $scope.removetitle = true;
            }
            else {
                if ($scope.data && $scope.ngmodel) {
                    if ($scope.takecode == "true")
                        var itemname = $filter('filter')($scope.data, { code: $scope.ngmodel });
                    else
                        var itemname = $filter('filter')($scope.data, { id: $scope.ngmodel });

                    if (itemname) {
                        $scope.removetitle = true;
                        if (itemname[0])
                            $scope.selectedText = itemname[0].name;
                        else
                            $scope.selectedText = "";
                        
                    }
                }
            }
            $scope.IsDisabled = true;
            $scope.hideSpan = $scope.default ? true : false;
            if ($scope.titleclass == "sidebarcity") {
                $("#itemselect").css("width", "100px");
                $("." + $scope.titleclass).hide();
            }
            if ($scope.data)
                $scope.config = {
                    setHeight: 40 * $scope.data.length
                };
            $scope.changeValue = function (item) {
                $scope.removetitle = true;
                $scope.hideSpan = $scope.default ? true : false;
                if ($scope.simpledata == "true")
                    if ($scope.takecode == "true")
                        $scope.ngmodel = item.code;
                    else
                        $scope.ngmodel = item.id;
                if ($scope.useSelectedText)
                    $scope.selectedText = item.name;
                else
                    $scope.selectedItem = item;
            };
        }
    }
}]);
